// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import MapController from "./map_controller"
application.register("map", MapController)

import FormMapController from "./form_map_controller"
application.register("form_map", FormMapController)

import FormRouteController from "./form_route_controller"
application.register("form_route", FormRouteController)

import SlugController from "./slug_controller"
application.register("slug", SlugController)

import ShowMapController from "./show_map_controller"
application.register("show-map", ShowMapController)

import PinPickerController from "./pin_picker_controller"
application.register("pin-picker", PinPickerController)

import ArticleGalleryController from "./article_gallery_controller"
application.register("article_gallery", ArticleGalleryController)

import GalleryLightboxController from "./gallery_lightbox_controller"
application.register("gallery-lightbox", GalleryLightboxController)
